###
  PickerView stores the value of a picker element, handles interaction and
  a scrolling element. While it doesn't apply transforms to the scroller, it
  provides feedback via a "change" event allowing manipulation by it's parent.

  Properties:
    picker.value: Current value of the picker

    This attribute is also available as a data attribute on picker.el.

  Public methods:
    picker.toggleUp(boolean)
    picker.toggleDown(boolean)
    picker.setBy(diff)

  Events:
    change: (picker, isIncreasing)

  Options:
    value: Initial value of the picker
###

class PickerView extends Backbone.View

  initialize: (@options) ->
    @value = @el.dataset.value = @options.value
    @scroller = @el.querySelector(".number-picker-nums-scroller")
    @getOffset()

  events: ->
    "iostap .number-picker-arr-up": "onTapUp"
    "iostap .number-picker-arr-down": "onTapDown"

  setBy: (diff) ->
    value = @value + diff
    value = 0 if value > 9
    value = 9 if value < 0

    @value = @el.dataset.value = value

    @trigger("change", this, diff)

  onTapUp: ->
    @setBy(1, true)

  onTapDown: ->
    @setBy(-1, false)

  toggleUp: (enabled) ->
    @el.classList.toggle("disabled-up", enabled)

  toggleDown: (enabled) ->
    @el.classList.toggle("disabled-down", enabled)

  getOffset: ->
    el = @el.querySelector(".number-picker-nums")
    @offset =
      width: el.offsetWidth
      height: el.offsetHeight

module.exports = PickerView
